import "./App.css";
import React from "react";
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Test from "./pages/Test";
import Login from "./pages/Login";
import UsersGrid from "./pages_secured/UsersGrid";
import ProtectedRoute from "./components/ProtectedRoute";
import Logout from "./pages/Logout";
import TestSecured from "./pages_secured/TestSecured";
import Mail from "./pages_secured/Mail";
import Rgpd from "./pages/Rgpd";
import TokenRefresher from "./components/TokenRefresher";

function App() {
  const [user, setUser] = useState(null); // simulate a login
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("idToken");
    const refreshToken = sessionStorage.getItem("refreshToken");

    if (token && refreshToken) {
      setUser(true);
    } else {
      setUser(null); // session expirée ou premier lancement
    }

    setLoadingUser(false);
  }, []);

  return (
    <Router>
      {/*<TokenRefresher setUser={setUser} />*/}
      {loadingUser ? (
        <p>Chargement de l'utilisateur...</p>
      ) : (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rgpd" element={<Rgpd />} />
          <Route path="/test" element={<Test />} />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/users"
            element={
              <ProtectedRoute user={user}>
                <UsersGrid />
              </ProtectedRoute>
            }
          />
          <Route
            path="/testsecured"
            element={
              <ProtectedRoute user={user}>
                <TestSecured />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mail"
            element={
              <ProtectedRoute user={user}>
                <Mail />
              </ProtectedRoute>
            }
          />
        </Routes>
      )}
    </Router>
  );
}

export default App;
